import { Directive, Input, SimpleChanges } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS, ValidatorFn } from '@angular/forms';

export function Length(length: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    return control.value ? (control.value.length != length ? { 'appLength': { value: control.value } } : null) : null;
  };
}

@Directive({
  selector: '[appLength]',
  providers: [{ provide: NG_VALIDATORS, useExisting: LengthDirective, multi: true }]
})
export class LengthDirective {
  @Input('appLength') length: number;
  @Input('appLengthMessage') message: string;

  validate(control: AbstractControl): { [key: string]: any } {
    return this.length ? Length(this.length)(control)
      : null;
  }

  registerOnValidatorChange(fn: () => void): void { this._onChange = fn; }
  private _onChange: () => void;

  ngOnChanges(changes: SimpleChanges): void {
    

    if ('length' in changes || 'message' in changes) {

      if (this._onChange) this._onChange();
    }
  }

}
